<template>
  <div class="home">
    <section class="hero is-large is-primary is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            Project for student
          </h1>
          <h2 class="subtitle">
            we wish your dream comes true
          </h2>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home'
}
</script>
